import { At as e, Bt as t, Dt as n, Ft as r, It as i, Lt as a, Mt as o, Nt as s, Ot as c, Pt as l, Rt as u, Vt as d, _ as f, an as p, fn as m, g as h, gt as g, jt as ee, on as te, r as ne, zn as re, zt as ie } from "./blocks-D0lMxErU.js";
import { n as _, t as v } from "./BlockNoteExtension-B6RhuQ3V.js";
import { DOMSerializer as ae, Fragment as y, Slice as oe } from "prosemirror-model";
import { dropPoint as se } from "prosemirror-transform";
import { combineTransactionSteps as ce, findChildrenInRange as le, posToDOMRect as ue } from "@tiptap/core";
import { NodeSelection as de, Plugin as b, PluginKey as x, Selection as S, TextSelection as fe } from "prosemirror-state";
import { uuidv4 as pe } from "lib0/random";
import { DOMParser as me, Slice as he } from "@tiptap/pm/model";
import { CellSelection as ge, addColumnAfter as _e, addColumnBefore as ve, addRowAfter as ye, addRowBefore as be, deleteColumn as xe, deleteRow as Se, mergeCells as Ce, splitCell as we } from "prosemirror-tables";
import { Plugin as C, PluginKey as Te, TextSelection as Ee } from "@tiptap/pm/state";
import { Decoration as w, DecorationSet as T } from "prosemirror-view";
import { defaultSelectionBuilder as De, redoCommand as Oe, undoCommand as ke, yCursorPlugin as Ae, ySyncPlugin as je, yUndoPlugin as Me, yUndoPluginKey as E } from "y-prosemirror";
import Ne from "fast-deep-equal";
import * as D from "yjs";
import { history as Pe, redo as Fe, undo as Ie } from "@tiptap/pm/history";
//#region src/api/exporters/html/util/serializeBlocksExternalHTML.ts
function Le(e) {
	let t = Array.from(e.classList).filter((e) => !e.startsWith("bn-")) || [];
	t.length > 0 ? e.className = t.join(" ") : e.removeAttribute("class");
}
function Re(t, n, r, i) {
	let a;
	if (!n) throw Error("blockContent is required");
	if (typeof n == "string") a = e([n], t.pmSchema, i?.blockType);
	else if (Array.isArray(n)) a = e(n, t.pmSchema, i?.blockType);
	else if (n.type === "tableContent") a = ee(n, t.pmSchema);
	else throw new re(n.type);
	let o = (i?.document ?? document).createDocumentFragment();
	for (let e of a) if (e.type.name !== "text" && t.schema.inlineContentSchema[e.type.name]) {
		let n = t.schema.inlineContentSpecs[e.type.name].implementation;
		if (n) {
			let a = te(e, t.schema.inlineContentSchema, t.schema.styleSchema), s = n.toExternalHTML ? n.toExternalHTML(a, t) : n.render.call({
				renderType: "dom",
				props: void 0
			}, a, () => {}, t);
			if (s) {
				if (o.appendChild(s.dom), s.contentDOM) {
					let t = r.serializeFragment(e.content, i);
					s.contentDOM.dataset.editable = "", s.contentDOM.appendChild(t);
				}
				continue;
			}
		}
	} else if (e.type.name === "text") {
		let n = document.createTextNode(e.textContent);
		for (let r of e.marks.toReversed()) if (r.type.name in t.schema.styleSpecs) {
			let e = (t.schema.styleSpecs[r.type.name].implementation.toExternalHTML ?? t.schema.styleSpecs[r.type.name].implementation.render)(r.attrs.stringValue, t);
			e.contentDOM.appendChild(n), n = e.dom;
		} else {
			let e = r.type.spec.toDOM(r, !0), t = ae.renderSpec(document, e);
			t.contentDOM.appendChild(n), n = t.dom;
		}
		o.appendChild(n);
	} else {
		let t = r.serializeFragment(y.from([e]), i);
		o.appendChild(t);
	}
	return o.childNodes.length === 1 && o.firstChild?.nodeType === 1 && Le(o.firstChild), o;
}
function ze(e, t, n, r, i, a, o, s) {
	let c = s?.document ?? document, l = t.pmSchema.nodes.blockContainer, u = n.props || {};
	for (let [e, r] of Object.entries(t.schema.blockSchema[n.type].propSchema)) !(e in u) && r.default !== void 0 && (u[e] = r.default);
	let d = l.spec?.toDOM?.(l.create({
		id: n.id,
		...u
	})), f = Array.from(d.dom.attributes), p = t.blockImplementations[n.type].implementation, m = p.toExternalHTML?.call({}, {
		...n,
		props: u
	}, t, { nestingLevel: o }) || p.render.call({}, {
		...n,
		props: u
	}, t), h = c.createDocumentFragment();
	if (m.dom.classList.contains("bn-block-content")) {
		let e = [...f, ...Array.from(m.dom.attributes)].filter((e) => e.name.startsWith("data") && e.name !== "data-content-type" && e.name !== "data-file-block" && e.name !== "data-node-view-wrapper" && e.name !== "data-node-type" && e.name !== "data-id" && e.name !== "data-editable");
		for (let t of e) m.dom.firstChild.setAttribute(t.name, t.value);
		Le(m.dom.firstChild), o > 0 && m.dom.firstChild.setAttribute("data-nesting-level", o.toString()), h.append(...Array.from(m.dom.childNodes));
	} else h.append(m.dom), o > 0 && m.dom.setAttribute("data-nesting-level", o.toString());
	if (m.contentDOM && n.content) {
		let e = Re(t, n.content, r, {
			...s,
			blockType: n.type
		});
		m.contentDOM.appendChild(e);
	}
	let g;
	if (i.has(n.type) ? g = "OL" : a.has(n.type) && (g = "UL"), g) {
		if (e.lastChild?.nodeName !== g) {
			let t = c.createElement(g);
			g === "OL" && "start" in u && u.start && u?.start !== 1 && t.setAttribute("start", u.start + ""), e.append(t);
		}
		e.lastChild.appendChild(h);
	} else e.append(h);
	if (n.children && n.children.length > 0) {
		let l = c.createDocumentFragment();
		if (Be(l, t, n.children, r, i, a, o + 1, s), e.lastChild?.nodeName === "UL" || e.lastChild?.nodeName === "OL") for (; l.firstChild?.nodeName === "UL" || l.firstChild?.nodeName === "OL";) e.lastChild.lastChild.appendChild(l.firstChild);
		"childrenDOM" in m && m.childrenDOM ? m.childrenDOM.append(l) : t.pmSchema.nodes[n.type].isInGroup("blockContent") ? e.append(l) : m.contentDOM?.append(l);
	}
}
var Be = (e, t, n, r, i, a, o = 0, s) => {
	for (let c of n) ze(e, t, c, r, i, a, o, s);
}, Ve = (e, t, n, r, i, a) => {
	let o = (a?.document ?? document).createDocumentFragment();
	return Be(o, e, t, n, r, i, 0, a), o;
}, O = (e, t) => {
	let n = ae.fromSchema(e);
	return {
		exportBlocks: (e, r) => {
			let i = Ve(t, e, n, new Set(["numberedListItem"]), new Set([
				"bulletListItem",
				"checkListItem",
				"toggleListItem"
			]), r), a = document.createElement("div");
			return a.append(i), a.innerHTML;
		},
		exportInlineContent: (e, r) => {
			let i = Re(t, e, n, r), a = document.createElement("div");
			return a.append(i.cloneNode(!0)), a.innerHTML;
		}
	};
};
//#endregion
//#region src/api/getBlocksChangedByTransaction.ts
function He(e, t) {
	if (t === 0) return;
	let n = e.resolve(t);
	for (let e = n.depth; e > 0; e--) {
		let t = n.node(e);
		if (c(t)) return t.attrs.id;
	}
}
function Ue(e) {
	return e.getMeta("paste") ? { type: "paste" } : e.getMeta("uiEvent") === "drop" ? { type: "drop" } : e.getMeta("history$") ? { type: e.getMeta("history$").redo ? "redo" : "undo" } : e.getMeta("y-sync$") ? e.getMeta("y-sync$").isUndoRedoOperation ? { type: "undo-redo" } : { type: "yjs-remote" } : { type: "local" };
}
function We(e) {
	let t = {}, n = {}, r = m(e);
	return e.descendants((i, a) => {
		if (!c(i)) return !0;
		let o = He(e, a), s = o ?? "__root__";
		n[s] || (n[s] = []);
		let l = p(i, r);
		return t[i.attrs.id] = {
			block: l,
			parentId: o
		}, n[s].push(i.attrs.id), !0;
	}), {
		byId: t,
		childrenByParent: n
	};
}
function Ge(e, t) {
	let n = /* @__PURE__ */ new Set();
	if (!e || !t) return n;
	let r = new Set(e), i = t.filter((e) => r.has(e)), a = e.filter((e) => i.includes(e));
	if (a.length <= 1 || i.length <= 1) return n;
	let o = {};
	for (let e = 0; e < a.length; e++) o[a[e]] = e;
	let s = i.map((e) => o[e]), c = s.length, l = [], u = [], d = Array(c).fill(-1), f = (e, t) => {
		let n = 0, r = e.length;
		for (; n < r;) {
			let i = n + r >>> 1;
			e[i] < t ? n = i + 1 : r = i;
		}
		return n;
	};
	for (let e = 0; e < c; e++) {
		let t = s[e], n = f(l, t);
		n > 0 && (d[e] = u[n - 1]), n === l.length ? (l.push(t), u.push(e)) : (l[n] = t, u[n] = e);
	}
	let p = /* @__PURE__ */ new Set(), m = u[u.length - 1] ?? -1;
	for (; m !== -1;) p.add(m), m = d[m];
	for (let e = 0; e < i.length; e++) p.has(e) || n.add(i[e]);
	return n;
}
function Ke(e, t = []) {
	let n = Ue(e), r = ce(e.before, [e, ...t]), i = We(r.before), a = We(r.doc), o = [], s = /* @__PURE__ */ new Set();
	Object.keys(a.byId).filter((e) => !(e in i.byId)).forEach((e) => {
		o.push({
			type: "insert",
			block: a.byId[e].block,
			source: n,
			prevBlock: void 0
		}), s.add(e);
	}), Object.keys(i.byId).filter((e) => !(e in a.byId)).forEach((e) => {
		o.push({
			type: "delete",
			block: i.byId[e].block,
			source: n,
			prevBlock: void 0
		}), s.add(e);
	}), Object.keys(a.byId).filter((e) => e in i.byId).forEach((e) => {
		let t = i.byId[e], r = a.byId[e];
		t.parentId === r.parentId ? Ne({
			...t.block,
			children: void 0
		}, {
			...r.block,
			children: void 0
		}) || (o.push({
			type: "update",
			block: r.block,
			prevBlock: t.block,
			source: n
		}), s.add(e)) : (o.push({
			type: "move",
			block: r.block,
			prevBlock: t.block,
			source: n,
			prevParent: t.parentId ? i.byId[t.parentId]?.block : void 0,
			currentParent: r.parentId ? a.byId[r.parentId]?.block : void 0
		}), s.add(e));
	});
	let c = i.childrenByParent, l = a.childrenByParent, u = new Set([...Object.keys(c), ...Object.keys(l)]), d = /* @__PURE__ */ new Set();
	return u.forEach((e) => {
		let t = Ge(c[e], l[e]);
		t.size !== 0 && t.forEach((t) => {
			let r = i.byId[t], c = a.byId[t];
			!r || !c || r.parentId === c.parentId && (s.has(t) || (r.parentId ?? "__root__") === e && (d.has(t) || (d.add(t), o.push({
				type: "move",
				block: c.block,
				prevBlock: r.block,
				source: n,
				prevParent: r.parentId ? i.byId[r.parentId]?.block : void 0,
				currentParent: c.parentId ? a.byId[c.parentId]?.block : void 0
			}), s.add(t))));
		});
	}), o;
}
//#endregion
//#region src/extensions/BlockChange/BlockChange.ts
var qe = v(() => {
	let e = [];
	return {
		key: "blockChange",
		prosemirrorPlugins: [new b({
			key: new x("blockChange"),
			filterTransaction: (t) => {
				let n;
				return e.reduce((e, r) => e === !1 ? e : r({
					getChanges() {
						return n || (n = Ke(t), n);
					},
					tr: t
				}) !== !1, !0);
			}
		})],
		subscribe(t) {
			return e.push(t), () => {
				e.splice(e.indexOf(t), 1);
			};
		}
	};
});
//#endregion
//#region src/extensions/Collaboration/YCursorPlugin.ts
function Je(e) {
	let t = e.charAt(0) === "#" ? e.substring(1, 7) : e, n = parseInt(t.substring(0, 2), 16), r = parseInt(t.substring(2, 4), 16), i = parseInt(t.substring(4, 6), 16), a = [
		n / 255,
		r / 255,
		i / 255
	].map((e) => e <= .03928 ? e / 12.92 : ((e + .055) / 1.055) ** 2.4);
	return .2126 * a[0] + .7152 * a[1] + .0722 * a[2] <= .179;
}
function Ye(e) {
	let t = document.createElement("span");
	t.classList.add("bn-collaboration-cursor__base");
	let n = document.createElement("span");
	n.setAttribute("contentedEditable", "false"), n.classList.add("bn-collaboration-cursor__caret"), n.setAttribute("style", `background-color: ${e.color}; color: ${Je(e.color) ? "white" : "black"}`);
	let r = document.createElement("span");
	return r.classList.add("bn-collaboration-cursor__label"), r.setAttribute("style", `background-color: ${e.color}; color: ${Je(e.color) ? "white" : "black"}`), r.insertBefore(document.createTextNode(e.name), null), n.insertBefore(r, null), t.insertBefore(document.createTextNode("⁠"), null), t.insertBefore(n, null), t.insertBefore(document.createTextNode("⁠"), null), t;
}
var k = v(({ options: e }) => {
	let t = /* @__PURE__ */ new Map(), n = e.provider && "awareness" in e.provider && typeof e.provider.awareness == "object" ? e.provider.awareness : void 0;
	return n && ("setLocalStateField" in n && typeof n.setLocalStateField == "function" && n.setLocalStateField("user", e.user), "on" in n && typeof n.on == "function" && e.showCursorLabels !== "always" && n.on("change", ({ updated: e }) => {
		for (let n of e) {
			let e = t.get(n);
			e && (setTimeout(() => {
				e.element.setAttribute("data-active", "");
			}, 10), e.hideTimeout && clearTimeout(e.hideTimeout), t.set(n, {
				element: e.element,
				hideTimeout: setTimeout(() => {
					e.element.removeAttribute("data-active");
				}, 2e3)
			}));
		}
	})), {
		key: "yCursor",
		prosemirrorPlugins: [n ? Ae(n, {
			selectionBuilder: De,
			cursorBuilder(n, r) {
				let i = t.get(r);
				if (!i) {
					let a = (e.renderCursor ?? Ye)(n);
					e.showCursorLabels !== "always" && (a.addEventListener("mouseenter", () => {
						let e = t.get(r);
						e.element.setAttribute("data-active", ""), e.hideTimeout && (clearTimeout(e.hideTimeout), t.set(r, {
							element: e.element,
							hideTimeout: void 0
						}));
					}), a.addEventListener("mouseleave", () => {
						let e = t.get(r);
						t.set(r, {
							element: e.element,
							hideTimeout: setTimeout(() => {
								e.element.removeAttribute("data-active");
							}, 2e3)
						});
					})), i = {
						element: a,
						hideTimeout: void 0
					}, t.set(r, i);
				}
				return i.element;
			}
		}) : void 0].filter(Boolean),
		dependsOn: ["ySync"],
		updateUser(e) {
			n?.setLocalStateField("user", e);
		}
	};
}), A = v(({ options: e }) => ({
	key: "ySync",
	prosemirrorPlugins: [je(e.fragment)],
	runsBefore: ["default"]
})), j = v(() => ({
	key: "yUndo",
	prosemirrorPlugins: [Me()],
	dependsOn: ["yCursor", "ySync"],
	undoCommand: ke,
	redoCommand: Oe
}));
//#endregion
//#region src/extensions/Collaboration/ForkYDoc.ts
function Xe(e, t) {
	let n = e.doc;
	if (e._item === null) {
		let r = Array.from(n.share.keys()).find((t) => n.share.get(t) === e);
		if (r == null) throw Error("type does not exist in other ydoc");
		return t.get(r, e.constructor);
	} else {
		let n = e._item, r = t.store.clients.get(n.id.client) ?? [];
		return r[D.findIndexSS(r, n.id.clock)].content.type;
	}
}
var Ze = v(({ editor: e, options: t }) => {
	let n, r = _({ isForked: !1 });
	return {
		key: "yForkDoc",
		store: r,
		fork() {
			if (n) return;
			let i = t.fragment;
			if (!i) throw Error("No fragment to fork from");
			let a = new D.Doc();
			D.applyUpdate(a, D.encodeStateAsUpdate(i.doc));
			let o = Xe(i, a);
			n = {
				undoStack: E.getState(e.prosemirrorState).undoManager.undoStack,
				originalFragment: i,
				forkedFragment: o
			}, e.unregisterExtension([
				j,
				k,
				A
			]);
			let s = {
				...t,
				fragment: o
			};
			e.registerExtension([A(s), j()]), r.setState({ isForked: !0 });
		},
		merge({ keepChanges: i }) {
			if (!n) return;
			e.unregisterExtension([
				"ySync",
				"yCursor",
				"yUndo"
			]);
			let { originalFragment: a, forkedFragment: o, undoStack: s } = n;
			if (e.registerExtension([
				A(t),
				k(t),
				j()
			]), E.getState(e.prosemirrorState).undoManager.undoStack = s, i) {
				let t = D.encodeStateAsUpdate(o.doc, D.encodeStateVector(a.doc));
				D.applyUpdate(a.doc, t, e);
			}
			n = void 0, r.setState({ isForked: !1 });
		}
	};
}), M = (e, t) => {
	t(e), e.forEach((e) => {
		e instanceof D.XmlElement && M(e, t);
	});
}, Qe = [(e, t) => {
	let n = /* @__PURE__ */ new Map();
	return e.forEach((e) => {
		e instanceof D.XmlElement && M(e, (e) => {
			if (e.nodeName === "blockContainer" && e.hasAttribute("id")) {
				let t = e.getAttribute("textColor"), r = e.getAttribute("backgroundColor"), i = {
					textColor: t === g.textColor.default ? void 0 : t,
					backgroundColor: r === g.backgroundColor.default ? void 0 : r
				};
				(i.textColor || i.backgroundColor) && n.set(e.getAttribute("id"), i);
			}
		});
	}), n.size === 0 ? !1 : (t.doc.descendants((e, r) => {
		if (e.type.name === "blockContainer" && n.has(e.attrs.id)) {
			let i = t.doc.nodeAt(r + 1);
			if (!i) throw Error("No element found");
			t.setNodeMarkup(r + 1, void 0, {
				...i.attrs,
				...n.get(e.attrs.id)
			});
		}
	}), !0);
}], $e = v(({ options: e }) => {
	let t = !1;
	return {
		key: "schemaMigration",
		prosemirrorPlugins: [new C({
			key: new Te("schemaMigration"),
			appendTransaction: (n, r, i) => {
				if (t || !n.some((e) => e.getMeta("y-sync$")) || n.every((e) => !e.docChanged) || !e.fragment.firstChild) return;
				let a = i.tr;
				for (let t of Qe) t(e.fragment, a);
				if (t = !0, a.docChanged) return a;
			}
		})]
	};
});
//#endregion
//#region src/extensions/DropCursor/utils.ts
function et(e, t) {
	return !e || !t ? !1 : !!e.closest(`.${t}`);
}
function tt(e, t, n, r, i) {
	let a = e.state.doc.resolve(t.pos);
	if (a.parent.inlineContent || t.orientation === "inline") return null;
	let o = a.nodeBefore, s = a.nodeAfter;
	if (!o && !s) return null;
	let c = t.orientation === "block-vertical-left" || t.orientation === "block-vertical-right", l = c ? t.pos : t.pos - (o ? o.nodeSize : 0), u = e.nodeDOM(l);
	if (!u) return null;
	let d = u.getBoundingClientRect();
	if (c) {
		let e = n / 2 * r, i = t.orientation === "block-vertical-left" ? d.left : d.right;
		return {
			left: i - e,
			right: i + e,
			top: d.top,
			bottom: d.bottom
		};
	}
	let f = o ? d.bottom : d.top;
	o && s && (f = (f + e.nodeDOM(t.pos).getBoundingClientRect().top) / 2);
	let p = n / 2 * i;
	return {
		left: d.left,
		right: d.right,
		top: f - p,
		bottom: f + p
	};
}
function nt(e, t, n, r) {
	let i = e.coordsAtPos(t.pos), a = n / 2 * r;
	return {
		left: i.left - a,
		right: i.left + a,
		top: i.top,
		bottom: i.bottom
	};
}
function rt(e, t) {
	e.classList.toggle("prosemirror-dropcursor-inline", t === "inline"), e.classList.toggle("prosemirror-dropcursor-block-horizontal", t === "block-horizontal"), e.classList.toggle("prosemirror-dropcursor-block-vertical-left", t === "block-vertical-left"), e.classList.toggle("prosemirror-dropcursor-block-vertical-right", t === "block-vertical-right"), e.classList.toggle("prosemirror-dropcursor-block", t === "block-horizontal"), e.classList.toggle("prosemirror-dropcursor-vertical", t === "block-vertical-left" || t === "block-vertical-right");
}
function it(e) {
	if (!e || e === document.body && getComputedStyle(e).position === "static") return {
		parentLeft: -window.pageXOffset,
		parentTop: -window.pageYOffset
	};
	let t = e.getBoundingClientRect(), n = t.width / e.offsetWidth, r = t.height / e.offsetHeight;
	return {
		parentLeft: t.left - e.scrollLeft * n,
		parentTop: t.top - e.scrollTop * r
	};
}
//#endregion
//#region src/extensions/DropCursor/DropCursor.ts
var at = "bn-drag-exclude", ot = v(({ editor: e, options: t }) => {
	let n = null, r = null, i = -1, a = null, o = {
		width: t.dropCursor?.width ?? 5,
		color: t.dropCursor?.color ?? "#ddeeff",
		exclude: t.dropCursor?.exclude ?? "bn-drag-exclude",
		hooks: t.dropCursor?.hooks
	}, s = (e) => {
		e?.pos === n?.pos && e?.orientation === n?.orientation || (n = e, e == null ? (r && r.parentNode && r.parentNode.removeChild(r), r = null) : c());
	}, c = () => {
		if (!n) return;
		let t = e.prosemirrorView, i = t.dom, a = i.getBoundingClientRect(), s = a.width / i.offsetWidth, c = a.height / i.offsetHeight, l = tt(t, n, o.width, s, c) ?? nt(t, n, o.width, s), u = t.dom.offsetParent;
		r || (r = u.appendChild(document.createElement("div")), r.style.cssText = "position: absolute; z-index: 50; pointer-events: none;", o.color && (r.style.backgroundColor = o.color)), rt(r, n.orientation);
		let { parentLeft: d, parentTop: f } = it(u);
		r.style.left = (l.left - d) / s + "px", r.style.top = (l.top - f) / c + "px", r.style.width = (l.right - l.left) / s + "px", r.style.height = (l.bottom - l.top) / c + "px";
	}, l = (e) => {
		clearTimeout(i), i = window.setTimeout(() => s(null), e);
	}, u = (e) => {
		let t = e;
		a = t.target instanceof Element ? t.target : null;
	}, d = (t) => {
		let n = t;
		if (a && et(a, o.exclude) || n.target instanceof Element && et(n.target, o.exclude)) return;
		let r = e.prosemirrorView;
		if (!r.editable) return;
		let i = r.posAtCoords({
			left: n.clientX,
			top: n.clientY
		}), c = i && i.inside >= 0 && r.state.doc.nodeAt(i.inside), u = c && c.type.spec.disableDropCursor, d = typeof u == "function" ? u(r, i, n) : u;
		if (i && !d) {
			let t = i.pos;
			if (r.dragging && r.dragging.slice) {
				let e = se(r.state.doc, t, r.dragging.slice);
				e != null && (t = e);
			}
			let a = !r.state.doc.resolve(t).parent.inlineContent, c = {
				pos: t,
				orientation: a ? "block-horizontal" : "inline"
			}, u = c;
			if (o.hooks?.computeDropPosition) {
				let t = o.hooks.computeDropPosition({
					editor: e,
					event: n,
					view: r,
					defaultPosition: c
				});
				if (t === null) {
					s(null);
					return;
				}
				u = t;
			}
			s(u), l(5e3);
		}
	}, f = (t) => {
		let n = t;
		(!(n.relatedTarget instanceof Node) || !e.prosemirrorView.dom.contains(n.relatedTarget)) && s(null);
	}, p = () => {
		l(20);
	}, m = () => {
		l(20), a = null;
	};
	return {
		key: "dropCursor",
		mount({ signal: e, dom: t, root: n }) {
			n.addEventListener("dragstart", u, {
				capture: !0,
				signal: e
			}), t.addEventListener("dragover", d, { signal: e }), t.addEventListener("dragleave", f, { signal: e }), t.addEventListener("drop", p, { signal: e }), t.addEventListener("dragend", m, { signal: e }), e.addEventListener("abort", () => {
				clearTimeout(i), s(null);
			});
		}
	};
}), st = v(() => ({
	key: "history",
	prosemirrorPlugins: [Pe()],
	undoCommand: Ie,
	redoCommand: Fe
})), ct = v(({ editor: e }) => {
	function t(t) {
		let n = e.prosemirrorView.nodeDOM(t);
		for (; n && n.parentElement;) {
			if (n.nodeName === "A") return n;
			n = n.parentElement;
		}
		return null;
	}
	function n(t) {
		let n = e.getLinkMarkAtPos(t);
		if (n) return {
			range: {
				from: n.from,
				to: n.to
			},
			mark: { attrs: { href: n.href } },
			get text() {
				return n.text;
			},
			get position() {
				return ue(e.prosemirrorView, n.from, n.to).toJSON();
			}
		};
	}
	function r() {
		return e.transact((e) => {
			if (e.selection.empty) return n(e.selection.anchor);
		});
	}
	return {
		key: "linkToolbar",
		getLinkAtSelection: r,
		getLinkElementAtPos: t,
		getMarkAtPos(e, t) {
			return n(e);
		},
		getLinkAtElement(t) {
			return e.transact(() => n(e.prosemirrorView.posAtDOM(t, 0) + 1));
		},
		editLink(t, n, r = e.transact((e) => e.selection.anchor)) {
			e.editLink(t, n, r);
		},
		deleteLink(t = e.transact((e) => e.selection.anchor)) {
			e.deleteLink(t);
		}
	};
}), lt = [
	"http",
	"https",
	"ftp",
	"ftps",
	"mailto",
	"tel",
	"callto",
	"sms",
	"cid",
	"xmpp"
], ut = "https", dt = new x("node-selection-keyboard"), ft = v(() => ({
	key: "nodeSelectionKeyboard",
	prosemirrorPlugins: [new b({
		key: dt,
		props: { handleKeyDown: (e, t) => {
			if ("node" in e.state.selection) {
				if (t.ctrlKey || t.metaKey) return !1;
				if (t.key.length === 1) return t.preventDefault(), !0;
				if (t.key === "Enter" && !t.isComposing && !t.shiftKey && !t.altKey && !t.ctrlKey && !t.metaKey) {
					let t = e.state.tr;
					return e.dispatch(t.insert(e.state.tr.selection.$to.after(), e.state.schema.nodes.paragraph.createChecked()).setSelection(new fe(t.doc.resolve(e.state.tr.selection.$to.after() + 1)))), !0;
				}
			}
			return !1;
		} }
	})]
})), pt = new x("blocknote-placeholder"), mt = v(({ editor: e, options: t }) => {
	let n = t.placeholders;
	return {
		key: "placeholder",
		prosemirrorPlugins: [new b({
			key: pt,
			view: (t) => {
				let r = `placeholder-selector-${pe()}`;
				t.dom.classList.add(r);
				let i = document.createElement("style"), a = e._tiptapEditor.options.injectNonce;
				a && i.setAttribute("nonce", a), t.root instanceof window.ShadowRoot ? t.root.append(i) : t.root.head.appendChild(i);
				let o = i.sheet, s = (e = "") => `.${r} .bn-block-content${e}:has(.ProseMirror-trailingBreak:only-child):after`;
				try {
					let { default: e, emptyDocument: t, ...r } = n || {};
					for (let [e, t] of Object.entries(r)) {
						let n = `[data-content-type="${e}"]`;
						o.insertRule(`${s(n)} { content: ${JSON.stringify(t)}; }`);
					}
					o.insertRule(`${s("[data-is-only-empty-block]")} { content: ${JSON.stringify(t)}; }`), o.insertRule(`${s("[data-is-empty-and-focused]")} { content: ${JSON.stringify(e)}; }`);
				} catch (e) {
					console.warn("Failed to insert placeholder CSS rule - this is likely due to the browser not supporting certain CSS pseudo-element selectors (:has, :only-child:, or :before)", e);
				}
				return { destroy: () => {
					t.root instanceof window.ShadowRoot ? t.root.removeChild(i) : t.root.head.removeChild(i);
				} };
			},
			props: { decorations: (t) => {
				let { doc: n, selection: r } = t;
				if (!e.isEditable || !r.empty || r.$from.parent.type.spec.code) return;
				let i = [];
				t.doc.content.size === 6 && i.push(w.node(2, 4, { "data-is-only-empty-block": "true" }));
				let a = r.$anchor, o = a.parent;
				if (o.content.size === 0) {
					let e = a.before();
					i.push(w.node(e, e + o.nodeSize, { "data-is-empty-and-focused": "true" }));
				}
				return T.create(n, i);
			} }
		})]
	};
}), ht = new x("previous-blocks"), gt = {
	index: "index",
	level: "level",
	type: "type",
	depth: "depth",
	"depth-change": "depth-change"
}, _t = v(() => {
	let e;
	return {
		key: "previousBlockType",
		prosemirrorPlugins: [new b({
			key: ht,
			view(t) {
				return {
					update: async (t, n) => {
						this.key?.getState(t.state).updatedBlocks.size > 0 && (e = setTimeout(() => {
							t.dispatch(t.state.tr.setMeta(ht, { clearUpdate: !0 }));
						}, 0));
					},
					destroy: () => {
						e && clearTimeout(e);
					}
				};
			},
			state: {
				init() {
					return {
						prevTransactionOldBlockAttrs: {},
						currentTransactionOldBlockAttrs: {},
						updatedBlocks: /* @__PURE__ */ new Set()
					};
				},
				apply(e, t, n, r) {
					if (t.currentTransactionOldBlockAttrs = {}, t.updatedBlocks.clear(), !e.docChanged) return t;
					let i = e.changedRange();
					if (!i) return t;
					let a = e.mapping.invert(), o = {
						from: a.map(i.from, -1),
						to: a.map(i.to, 1)
					}, s = {}, c = le(n.doc, o, (e) => e.attrs.id), l = new Map(c.map((e) => [e.node.attrs.id, e])), u = le(r.doc, i, (e) => e.attrs.id);
					for (let e of u) {
						let i = l.get(e.node.attrs.id), a = i?.node.firstChild, o = e.node.firstChild;
						if (i && a && o) {
							let c = {
								index: o.attrs.index,
								level: o.attrs.level,
								type: o.type.name,
								depth: r.doc.resolve(e.pos).depth
							}, l = {
								index: a.attrs.index,
								level: a.attrs.level,
								type: a.type.name,
								depth: n.doc.resolve(i.pos).depth
							};
							s[e.node.attrs.id] = l, t.currentTransactionOldBlockAttrs[e.node.attrs.id] = l, (l.index !== c.index || l.level !== c.level || l.type !== c.type || l.depth !== c.depth) && (l["depth-change"] = l.depth - c.depth, t.updatedBlocks.add(e.node.attrs.id));
						}
					}
					return t.prevTransactionOldBlockAttrs = s, t;
				}
			},
			props: { decorations(e) {
				let t = this.getState(e);
				if (t.updatedBlocks.size === 0) return;
				let n = [];
				return e.doc.descendants((e, r) => {
					if (!e.attrs.id || !t.updatedBlocks.has(e.attrs.id)) return;
					let i = t.currentTransactionOldBlockAttrs[e.attrs.id], a = {};
					for (let [e, t] of Object.entries(i)) a["data-prev-" + gt[e]] = t || "none";
					n.push(w.node(r, r + e.nodeSize, { ...a }));
				}), T.create(e.doc, n);
			} }
		})]
	};
});
//#endregion
//#region src/extensions/getDraggableBlockFromElement.ts
function vt(e, t) {
	for (; e && e.parentElement && e.parentElement !== t.dom && e.getAttribute?.("data-node-type") !== "blockContainer";) e = e.parentElement;
	if (e.getAttribute?.("data-node-type") === "blockContainer") return {
		node: e,
		id: e.getAttribute("data-id")
	};
}
//#endregion
//#region src/api/exporters/markdown/htmlToMarkdown.ts
function yt(e) {
	let t = document.createElement("div");
	return t.innerHTML = e, N(t, {
		indent: "",
		inListItem: !1
	}).trim() + "\n";
}
function N(e, t) {
	let n = "", r = Array.from(e.childNodes);
	for (let e = 0; e < r.length; e++) {
		let i = r[e];
		n += P(i, t);
	}
	return n;
}
function P(e, t) {
	if (e.nodeType === 3) return e.textContent || "";
	if (e.nodeType !== 1) return "";
	let n = e;
	switch (n.tagName.toLowerCase()) {
		case "p": return bt(n, t);
		case "h1":
		case "h2":
		case "h3":
		case "h4":
		case "h5":
		case "h6": return F(n, t);
		case "blockquote": return xt(n, t);
		case "pre": return St(n, t);
		case "ul": return wt(n, t);
		case "ol": return Tt(n, t);
		case "table": return Dt(n, t);
		case "hr": return t.indent + "***\n\n";
		case "img": return kt(n, t);
		case "video": return At(n, t);
		case "audio": return jt(n, t);
		case "embed": return Mt(n, t);
		case "figure": return Nt(n, t);
		case "a": return H(n, t);
		case "details": return Lt(n, t);
		case "div": return N(n, t);
		case "br": return "";
		default: return N(n, t);
	}
}
function bt(e, t) {
	let n = zt(U(e));
	return t.inListItem ? n : t.indent + n + "\n\n";
}
function F(e, t) {
	let n = parseInt(e.tagName[1], 10), r = "#".repeat(n) + " ", i = U(e);
	return t.indent + r + i + "\n\n";
}
function xt(e, t) {
	let n = Array.from(e.children).filter((e) => {
		let t = e.tagName.toLowerCase();
		return [
			"p",
			"ul",
			"ol",
			"pre",
			"blockquote",
			"table",
			"hr"
		].includes(t);
	}), r;
	if (n.length > 0) {
		let e = [];
		for (let t of n) t.tagName.toLowerCase() === "p" ? e.push(U(t)) : e.push(P(t, {
			indent: "",
			inListItem: !1
		}).trim());
		r = e.join("\n\n");
	} else r = U(e);
	return r.split("\n").map((e) => t.indent + "> " + e).join("\n") + "\n\n";
}
function St(e, t) {
	let n = e.querySelector("code");
	if (!n) return "";
	let r = n.getAttribute("data-language") || Ct(n.className) || "", i = I(n), a = Math.max(0, ...(i.match(/`+/g) ?? []).map((e) => e.length)), o = "`".repeat(Math.max(3, a + 1));
	return i ? t.indent + o + r + "\n" + i + (i.endsWith("\n") ? "" : "\n") + o + "\n\n" : t.indent + o + r + "\n" + o + "\n\n";
}
function I(e) {
	let t = "";
	for (let n of Array.from(e.childNodes)) n.nodeType === 3 ? t += n.textContent || "" : n.nodeType === 1 && (n.tagName.toLowerCase() === "br" ? t += "\n" : t += I(n));
	return t;
}
function Ct(e) {
	let t = e.match(/language-(\S+)/);
	return t ? t[1] : "";
}
function wt(e, t) {
	let n = "", r = Array.from(e.children).filter((e) => e.tagName.toLowerCase() === "li");
	for (let e of r) n += L(e, "bullet", t);
	return t.inListItem || (n += "\n"), n;
}
function Tt(e, t) {
	let n = "", r = Array.from(e.children).filter((e) => e.tagName.toLowerCase() === "li"), i = parseInt(e.getAttribute("start") || "1", 10);
	for (let e = 0; e < r.length; e++) {
		let a = i + e;
		n += L(r[e], "ordered", t, a);
	}
	return t.inListItem || (n += "\n"), n;
}
function L(e, t, n, r) {
	let i = null, a = null;
	for (let t of Array.from(e.children)) {
		let e = t.tagName.toLowerCase();
		e === "input" && t.type === "checkbox" && (i = t), e === "details" && (a = t);
	}
	let o, s;
	i ? (o = `* ${i.checked ? "[x]" : "[ ]"} `, s = 2) : t === "ordered" ? (o = `${r}. `, s = o.length) : (o = "* ", s = 2);
	let c, l;
	if (a) {
		let e = a.querySelector("summary")?.querySelector("p");
		l = a, c = e ? U(e) : "";
	} else l = Et(e, i), c = l ? U(l) : "";
	let u = n.indent + o + c + "\n", d = n.indent + " ".repeat(s), f = {
		indent: d,
		inListItem: !0
	};
	if (a) {
		let e = a.querySelector("summary");
		for (let t of Array.from(a.children)) if (t !== e) if (t.tagName.toLowerCase() === "p") {
			let e = U(t);
			u += "\n" + d + e + "\n";
		} else u += P(t, f);
	}
	let p = Array.from(e.children);
	for (let e of p) {
		let t = e.tagName.toLowerCase();
		if (!(e === l || e === i) && t !== "input") if (t === "ul" || t === "ol") u += P(e, f);
		else if (t === "p") {
			let t = U(e);
			u += "\n" + d + t + "\n";
		} else u += "\n" + P(e, f);
	}
	return u;
}
function Et(e, t) {
	for (let n of Array.from(e.children)) {
		if (n === t || n.tagName.toLowerCase() === "input") continue;
		let e = n.tagName.toLowerCase();
		if (e === "p" || e === "span") return n;
	}
	return null;
}
function Dt(e, t) {
	let n = e.querySelector("colgroup"), r = 0;
	n && (r = n.querySelectorAll("col").length);
	let i = [], a = !1, o = e.querySelectorAll("tr"), s = [];
	o.forEach((e, t) => {
		s[t] || (s[t] = []);
		let n = e.querySelectorAll("th, td"), i = 0;
		n.forEach((e) => {
			for (; s[t][i] !== void 0;) i++;
			t === 0 && e.tagName.toLowerCase() === "th" && (a = !0);
			let n = Ot(U(e).trim()), r = parseInt(e.getAttribute("colspan") || "1", 10), o = parseInt(e.getAttribute("rowspan") || "1", 10);
			for (let e = 0; e < o; e++) for (let a = 0; a < r; a++) {
				let r = t + e;
				s[r] || (s[r] = []), s[r][i + a] = e === 0 && a === 0 ? n : "";
			}
			i += r;
		}), s[t] && (r = Math.max(r, s[t].length));
	});
	for (let e of s) {
		let t = [];
		for (let n = 0; n < r; n++) t.push(e && e[n] !== void 0 ? e[n] ?? "" : "");
		i.push(t);
	}
	if (i.length === 0) return "";
	let c = [];
	for (let e = 0; e < r; e++) {
		let t = 3;
		for (let n of i) {
			let r = e < n.length ? n[e].length : 0;
			t = Math.max(t, r);
		}
		c.push(Math.max(t, 10));
	}
	let l = "";
	if (a) {
		l += t.indent + R(i[0], c, r) + "\n", l += t.indent + z(c, r) + "\n";
		for (let e = 1; e < i.length; e++) l += t.indent + R(i[e], c, r) + "\n";
	} else {
		let e = Array(r).fill("");
		l += t.indent + R(e, c, r) + "\n", l += t.indent + z(c, r) + "\n";
		for (let e of i) l += t.indent + R(e, c, r) + "\n";
	}
	return l += "\n", l;
}
function Ot(e) {
	return e.replace(/\|/g, "\\|");
}
function R(e, t, n) {
	let r = [];
	for (let i = 0; i < n; i++) {
		let n = i < e.length ? e[i] : "";
		r.push(" " + n.padEnd(t[i]) + " ");
	}
	return "|" + r.join("|") + "|";
}
function z(e, t) {
	let n = [];
	for (let r = 0; r < t; r++) n.push(" " + "-".repeat(e[r]) + " ");
	return "|" + n.join("|") + "|";
}
function kt(e, t) {
	let n = e.getAttribute("src") || "", r = e.getAttribute("alt") || "";
	return n ? t.indent + `![${r}](${n})\n\n` : "\n\n";
}
function At(e, t) {
	let n = e.getAttribute("src") || e.getAttribute("data-url") || "", r = e.getAttribute("data-name") || e.getAttribute("title") || "";
	return n ? t.indent + `![${r}](${n})\n\n` : "\n\n";
}
function jt(e, t) {
	let n = e.getAttribute("src") || "";
	return n ? t.indent + `<audio src="${V(n)}" controls></audio>\n\n` : "\n\n";
}
function Mt(e, t) {
	let n = e.getAttribute("src") || "";
	return n ? t.indent + `[](${n})\n\n` : "\n\n";
}
function Nt(e, t) {
	let n = e.querySelector("img"), r = e.querySelector("video"), i = e.querySelector("audio"), a = e.querySelector("a"), o = e.querySelector("figcaption")?.textContent?.trim() || "";
	return n ? B("img", n.getAttribute("src") || "", n.getAttribute("alt") || "", o, t) : r ? B("video", r.getAttribute("src") || r.getAttribute("data-url") || "", r.getAttribute("data-name") || r.getAttribute("title") || "", o, t) : i ? B("audio", i.getAttribute("src") || "", "", o, t) : a ? H(a, t) : "";
}
function B(e, t, n, r, i) {
	if (!t) return "";
	if (!r && e !== "audio") return i.indent + `![${n}](${t})\n\n`;
	let a = n && n !== r ? e === "img" ? ` alt="${V(n)}"` : e === "video" ? ` data-name="${V(n)}"` : "" : "", o = e === "img" ? `<img${a} src="${V(t)}">` : `<${e} src="${V(t)}"${a} controls></${e}>`, s = r ? `<figcaption>${Pt(r)}</figcaption>` : "";
	return i.indent + `<figure>${o}${s}</figure>\n\n`;
}
function V(e) {
	return e.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function Pt(e) {
	return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function H(e, t) {
	let n = e.getAttribute("href") || "", r = e.textContent?.trim() || "";
	return n ? t.indent + Ft(r, n) + "\n\n" : t.indent + r + "\n\n";
}
function Ft(e, t) {
	return !e || e === t ? t : `[${e}](${It(t)})`;
}
function It(e) {
	return e.replace(/[\\()]/g, "\\$&");
}
function Lt(e, t) {
	let n = e.querySelector("summary");
	if (!n) return N(e, t);
	let r = n.querySelector("h1, h2, h3, h4, h5, h6");
	if (r) {
		let i = F(r, t);
		for (let r of Array.from(e.children)) r !== n && (i += P(r, t));
		return i;
	}
	return N(n, t);
}
function U(e) {
	let t = "";
	for (let n of Array.from(e.childNodes)) if (n.nodeType === 3) t += n.textContent || "";
	else if (n.nodeType === 1) {
		let e = n;
		switch (e.tagName.toLowerCase()) {
			case "strong":
			case "b": {
				let { content: n, trailing: r } = Rt(U(e));
				n ? t += `**${n}**${r}` : t += r;
				break;
			}
			case "em":
			case "i": {
				let { content: n, trailing: r } = Rt(U(e));
				n ? t += `*${n}*${r}` : t += r;
				break;
			}
			case "s":
			case "del":
				t += `~~${U(e)}~~`;
				break;
			case "code": {
				let n = e.textContent || "", r = Math.max(0, ...(n.match(/`+/g) ?? []).map((e) => e.length)), i = "`".repeat(r + 1), a = n.startsWith("`") || n.endsWith("`");
				t += i + (a ? ` ${n} ` : n) + i;
				break;
			}
			case "u":
				t += U(e);
				break;
			case "a": {
				let n = e.getAttribute("href") || "", r = U(e);
				t += Ft(r, n);
				break;
			}
			case "br":
				t += "\\\n";
				break;
			case "span":
				t += U(e);
				break;
			case "img": {
				let n = e.getAttribute("src") || "", r = e.getAttribute("alt") || "";
				t += `![${r}](${n})`;
				break;
			}
			case "video": {
				let n = e.getAttribute("src") || e.getAttribute("data-url") || "", r = e.getAttribute("data-name") || e.getAttribute("title") || "";
				t += `![${r}](${n})`;
				break;
			}
			case "p":
				t += U(e);
				break;
			case "input": break;
			default:
				t += U(e);
				break;
		}
	}
	return t;
}
function Rt(e) {
	let t = e.match(/^(.*?)(\s*)$/);
	return t ? {
		content: t[1],
		trailing: t[2]
	} : {
		content: e,
		trailing: ""
	};
}
function zt(e) {
	let t = e.replace(/^(\\\n)+/, "");
	return t = t.replace(/(\\\n)+$/, ""), t;
}
//#endregion
//#region src/api/exporters/markdown/markdownExporter.ts
function W(e) {
	return yt(e);
}
function Bt(e, t, n, r) {
	return W(O(t, n).exportBlocks(e, r));
}
//#endregion
//#region src/api/nodeConversions/fragmentToBlocks.ts
function Vt(e) {
	let t = [];
	return e.descendants((e) => {
		let n = m(e);
		return e.type.name === "blockContainer" && e.firstChild?.type.name === "blockGroup" ? !0 : e.type.name === "columnList" && e.childCount === 1 ? (e.firstChild?.forEach((e) => {
			t.push(p(e, n));
		}), !1) : e.type.isInGroup("bnBlock") ? (t.push(p(e, n)), !1) : !0;
	}), t;
}
//#endregion
//#region src/extensions/SideMenu/MultipleNodeSelection.ts
var G = class e extends S {
	nodes;
	constructor(e, t) {
		super(e, t);
		let n = e.node();
		this.nodes = [], e.doc.nodesBetween(e.pos, t.pos, (e, t, r) => {
			if (r !== null && r.eq(n)) return this.nodes.push(e), !1;
		});
	}
	static create(t, n, r = n) {
		return new e(t.resolve(n), t.resolve(r));
	}
	content() {
		return new oe(y.from(this.nodes), 0, 0);
	}
	eq(t) {
		if (!(t instanceof e) || this.nodes.length !== t.nodes.length || this.from !== t.from || this.to !== t.to) return !1;
		for (let e = 0; e < this.nodes.length; e++) if (!this.nodes[e].eq(t.nodes[e])) return !1;
		return !0;
	}
	map(t, n) {
		let r = n.mapResult(this.from), i = n.mapResult(this.to);
		return i.deleted ? S.near(t.resolve(r.pos)) : r.deleted ? S.near(t.resolve(i.pos)) : new e(t.resolve(r.pos), t.resolve(i.pos));
	}
	toJSON() {
		return {
			type: "multiple-node",
			anchor: this.anchor,
			head: this.head
		};
	}
};
S.jsonID("multiple-node", G);
//#endregion
//#region src/extensions/SideMenu/dragging.ts
var K;
function Ht(e, t) {
	let n, r, i = t.resolve(e.from).node().type.spec.group === "blockContent", a = t.resolve(e.to).node().type.spec.group === "blockContent", o = Math.min(e.$anchor.depth, e.$head.depth);
	if (i && a) {
		let i = e.$from.start(o - 1), a = e.$to.end(o - 1);
		n = t.resolve(i - 1).pos, r = t.resolve(a + 1).pos;
	} else n = e.from, r = e.to;
	return {
		from: n,
		to: r
	};
}
function Ut(e, t, n = t) {
	t === n && (n += e.state.doc.resolve(t + 1).node().nodeSize);
	let r = e.domAtPos(t).node.cloneNode(!0), i = e.domAtPos(t).node, a = (e, t) => Array.prototype.indexOf.call(e.children, t), o = a(i, e.domAtPos(t + 1).node.parentElement), s = a(i, e.domAtPos(n - 1).node.parentElement);
	for (let e = i.childElementCount - 1; e >= 0; e--) (e > s || e < o) && r.removeChild(r.children[e]);
	Wt(e.root), K = r, K.querySelectorAll("iframe, embed, object").forEach((e) => e.parentElement?.removeChild(e));
	let c = e.dom.className.split(" ").filter((e) => e !== "ProseMirror" && e !== "bn-root" && e !== "bn-editor").join(" ");
	K.className = K.className + " bn-drag-preview " + c, e.root instanceof ShadowRoot ? e.root.appendChild(K) : e.root.body.appendChild(K);
}
function Wt(e) {
	K !== void 0 && (e instanceof ShadowRoot ? e.removeChild(K) : e.body.removeChild(K), K = void 0);
}
function Gt(e, t, r) {
	if (!e.dataTransfer || r.headless) return;
	let i = r.prosemirrorView, a = n(t.id, i.state.doc);
	if (!a) throw Error(`Block with ID ${t.id} not found`);
	let o = a.posBeforeNode;
	if (o != null) {
		let t = i.state.selection, n = i.state.doc, { from: a, to: s } = Ht(t, n), c = a <= o && o < s, l = t.$anchor.node() !== t.$head.node() || t instanceof G;
		c && l ? (i.dispatch(i.state.tr.setSelection(G.create(n, a, s))), Ut(i, a, s)) : (i.dispatch(i.state.tr.setSelection(de.create(i.state.doc, o))), Ut(i, o));
		let u = i.state.selection.content(), d = r.pmSchema, f = i.serializeForClipboard(u).dom.innerHTML, p = O(d, r), m = Vt(u.content), h = p.exportBlocks(m, {}), g = W(h);
		e.dataTransfer.clearData(), e.dataTransfer.setData("blocknote/html", f), e.dataTransfer.setData("text/html", h), e.dataTransfer.setData("text/plain", g), e.dataTransfer.effectAllowed = "move", e.dataTransfer.setDragImage(K, 0, 0);
	}
}
//#endregion
//#region src/extensions/SideMenu/SideMenu.ts
var Kt = 250;
function q(e, t, n = !0) {
	let r = e.root.elementsFromPoint(t.left, t.top);
	for (let i of r) if (e.dom.contains(i)) return n && i.closest("[data-node-type=columnList]") ? q(e, {
		left: t.left + 50,
		top: t.top
	}, !1) : vt(i, e);
}
function qt(e, t) {
	if (!t.dom.firstChild) return;
	let n = t.dom.firstChild.getBoundingClientRect(), r = q(t, {
		left: Math.min(Math.max(n.left + 10, e.x), n.right - 10),
		top: e.y
	});
	if (r) return q(t, {
		left: r.node.getBoundingClientRect().right - 10,
		top: e.y
	}, !1);
}
var J = class {
	state;
	emitUpdate;
	mousePos;
	hoveredBlock;
	menuFrozen = !1;
	isDragOrigin = !1;
	constructor(e, t, n) {
		this.editor = e, this.pmView = t, this.emitUpdate = () => {
			if (!this.state) throw Error("Attempting to update uninitialized side menu");
			n(this.state);
		}, this.pmView.root.addEventListener("dragstart", this.onDragStart), this.pmView.root.addEventListener("dragover", this.onDragOver), this.pmView.root.addEventListener("drop", this.onDrop, !0), this.pmView.root.addEventListener("dragend", this.onDragEnd, !0), this.pmView.root.addEventListener("mousemove", this.onMouseMove, !0), this.pmView.root.addEventListener("keydown", this.onKeyDown, !0);
	}
	updateState = (e) => {
		this.state = e, this.emitUpdate(this.state);
	};
	updateStateFromMousePos = () => {
		if (this.menuFrozen || !this.mousePos) return;
		let e = this.findClosestEditorElement({
			clientX: this.mousePos.x,
			clientY: this.mousePos.y
		});
		if (e?.element !== this.pmView.dom || e.distance > Kt) {
			this.state?.show && (this.state.show = !1, this.updateState(this.state));
			return;
		}
		let t = qt(this.mousePos, this.pmView);
		if (!t || !this.editor.isEditable) {
			this.state?.show && (this.state.show = !1, this.updateState(this.state));
			return;
		}
		if (!(this.state?.show && this.hoveredBlock?.hasAttribute("data-id") && this.hoveredBlock?.getAttribute("data-id") === t.id) && (this.hoveredBlock = t.node, this.editor.isEditable)) {
			let e = t.node.getBoundingClientRect(), n = t.node.closest("[data-node-type=column]");
			this.state = {
				show: !0,
				referencePos: new DOMRect(n ? n.firstElementChild.getBoundingClientRect().x : this.pmView.dom.firstChild.getBoundingClientRect().x, e.y, e.width, e.height),
				block: this.editor.getBlock(this.hoveredBlock.getAttribute("data-id"))
			}, this.updateState(this.state);
		}
	};
	onDragStart = (e) => {
		let t = e.dataTransfer?.getData("blocknote/html");
		if (!t || this.pmView.dragging) return;
		let n = document.createElement("div");
		n.innerHTML = t;
		let r = me.fromSchema(this.pmView.state.schema).parse(n, { topNode: this.pmView.state.schema.nodes.blockGroup.create() });
		this.pmView.dragging = {
			slice: new he(r.content, 0, 0),
			move: !0
		};
	};
	findClosestEditorElement = (e) => {
		let t = Array.from(this.pmView.root.querySelectorAll(".bn-editor"));
		if (t.length === 0) return null;
		let n = t[0], r = Number.MAX_VALUE;
		return t.forEach((t) => {
			let i = t.querySelector(".bn-block-group").getBoundingClientRect(), a = e.clientX < i.left ? i.left - e.clientX : e.clientX > i.right ? e.clientX - i.right : 0, o = e.clientY < i.top ? i.top - e.clientY : e.clientY > i.bottom ? e.clientY - i.bottom : 0, s = Math.sqrt(a ** 2 + o ** 2);
			s < r && (r = s, n = t);
		}), {
			element: n,
			distance: r
		};
	};
	onDragOver = (e) => {
		if (e.synthetic || !(this.pmView.dragging !== null || this.isDragOrigin || e.dataTransfer?.types.includes("blocknote/html") || e.target instanceof Node && this.pmView.dom.contains(e.target))) return;
		let t = this.getDragEventContext(e);
		if (!t || !t.isDropPoint) {
			this.closeDropCursor();
			return;
		}
		t.isDropPoint && !t.isDropWithinEditorBounds && this.dispatchSyntheticEvent(e);
	};
	closeDropCursor = () => {
		let e = new Event("dragleave", { bubbles: !1 });
		e.synthetic = !0, this.pmView.dom.dispatchEvent(e);
	};
	getDragEventContext = (e) => {
		if (!(this.pmView.dragging !== null || this.isDragOrigin || e.dataTransfer?.types.includes("blocknote/html") || e.target instanceof Node && this.pmView.dom.contains(e.target))) return;
		let t = !e.dataTransfer?.types.includes("blocknote/html") && !!this.pmView.dragging, n = !!this.isDragOrigin, r = t || n, i = this.findClosestEditorElement(e);
		if (!i || i.distance > Kt) return;
		let a = i.element === this.pmView.dom, o = a && i.distance === 0;
		if (!(!a && !r)) return {
			isDropPoint: a,
			isDropWithinEditorBounds: o,
			isDragOrigin: r
		};
	};
	onDrop = (e) => {
		if (e.synthetic || !(this.pmView.dragging !== null || this.isDragOrigin || e.dataTransfer?.types.includes("blocknote/html") || e.target instanceof Node && this.pmView.dom.contains(e.target))) return;
		let t = this.getDragEventContext(e);
		if (!t) {
			this.closeDropCursor();
			return;
		}
		let { isDropPoint: n, isDropWithinEditorBounds: r, isDragOrigin: i } = t;
		if (!r && n && this.dispatchSyntheticEvent(e), n) {
			if (this.pmView.dragging) return;
			this.pmView.dispatch(this.pmView.state.tr.setSelection(Ee.create(this.pmView.state.tr.doc, this.pmView.state.tr.selection.anchor)));
			return;
		} else if (i) {
			setTimeout(() => this.pmView.dispatch(this.pmView.state.tr.deleteSelection()), 0);
			return;
		}
	};
	onDragEnd = (e) => {
		e.synthetic || (this.pmView.dragging = null);
	};
	onKeyDown = (e) => {
		this.state?.show && this.editor.isFocused() && (this.state.show = !1, this.emitUpdate(this.state));
	};
	onMouseMove = (e) => {
		if (this.menuFrozen) return;
		this.mousePos = {
			x: e.clientX,
			y: e.clientY
		};
		let t = this.pmView.dom.getBoundingClientRect();
		if (this.mousePos.x > t.left && this.mousePos.x < t.right && this.mousePos.y > t.top && this.mousePos.y < t.bottom && e && e.target && !this.editor.isWithinEditor(e.target)) {
			this.state?.show && (this.state.show = !1, this.emitUpdate(this.state));
			return;
		}
		this.updateStateFromMousePos();
	};
	dispatchSyntheticEvent(e) {
		let t = new Event(e.type, e), n = this.pmView.dom.firstChild.getBoundingClientRect();
		t.clientX = e.clientX, t.clientY = e.clientY, t.clientX = Math.min(Math.max(e.clientX, n.left), n.left + n.width), t.clientY = Math.min(Math.max(e.clientY, n.top), n.top + n.height), t.dataTransfer = e.dataTransfer, t.preventDefault = () => e.preventDefault(), t.synthetic = !0, this.pmView.dom.dispatchEvent(t);
	}
	update(e, t) {
		!t.doc.eq(this.pmView.state.doc) && this.state?.show && this.updateStateFromMousePos();
	}
	destroy() {
		this.state?.show && (this.state.show = !1, this.emitUpdate(this.state)), this.pmView.root.removeEventListener("mousemove", this.onMouseMove, !0), this.pmView.root.removeEventListener("dragstart", this.onDragStart), this.pmView.root.removeEventListener("dragover", this.onDragOver), this.pmView.root.removeEventListener("drop", this.onDrop, !0), this.pmView.root.removeEventListener("dragend", this.onDragEnd, !0), this.pmView.root.removeEventListener("keydown", this.onKeyDown, !0);
	}
}, Jt = new Te("SideMenuPlugin"), Yt = v(({ editor: e }) => {
	let t, n = _(void 0);
	return {
		key: "sideMenu",
		store: n,
		prosemirrorPlugins: [new C({
			key: Jt,
			view: (r) => (t = new J(e, r, (e) => {
				n.setState({ ...e });
			}), t)
		})],
		blockDragStart(n, r) {
			t && (t.isDragOrigin = !0), Gt(n, r, e);
		},
		blockDragEnd() {
			Wt(e.prosemirrorView.root), t && (t.isDragOrigin = !1), e.blur();
		},
		freezeMenu() {
			t.menuFrozen = !0, t.state.show = !0, t.emitUpdate(t.state);
		},
		unfreezeMenu() {
			t.menuFrozen = !1, t.state.show = !1, t.emitUpdate(t.state);
		},
		hideMenuIfNotFrozen() {
			!t.menuFrozen && t.state?.show && (t.state.show = !1, t.emitUpdate(t.state));
		}
	};
}), Y;
async function Xt() {
	return Y || (Y = (async () => {
		let [e, t] = await Promise.all([import("emoji-mart"), import("@emoji-mart/data")]), n = "default" in e ? e.default : e, r = "default" in t ? t.default : t;
		return await n.init({ data: r }), {
			emojiMart: n,
			emojiData: r
		};
	})(), Y);
}
async function Zt(e, t) {
	if (!("text" in e.schema.inlineContentSchema) || e.schema.inlineContentSchema.text !== ne.text) return [];
	let { emojiData: n, emojiMart: r } = await Xt();
	return (t.trim() === "" ? Object.values(n.emojis) : await r.SearchIndex.search(t)).map((t) => ({
		id: t.skins[0].native,
		onItemClick: () => e.insertInlineContent(t.skins[0].native + " ")
	}));
}
//#endregion
//#region src/extensions/TableHandles/TableHandles.ts
var X;
function Qt(e) {
	X || (X = document.createElement("div"), X.innerHTML = "_", X.style.opacity = "0", X.style.height = "1px", X.style.width = "1px", e instanceof Document ? e.body.appendChild(X) : e.appendChild(X));
}
function $t(e) {
	X &&= (e instanceof Document ? e.body.removeChild(X) : e.removeChild(X), void 0);
}
function Z(e) {
	return Array.prototype.indexOf.call(e.parentElement.childNodes, e);
}
function en(e) {
	let t = e;
	for (; t && t.nodeName !== "TD" && t.nodeName !== "TH" && !t.classList.contains("tableWrapper");) {
		if (t.classList.contains("ProseMirror")) return;
		let e = t.parentNode;
		if (!e || !(e instanceof Element)) return;
		t = e;
	}
	return t.nodeName === "TD" || t.nodeName === "TH" ? {
		type: "cell",
		domNode: t,
		tbodyNode: t.closest("tbody")
	} : {
		type: "wrapper",
		domNode: t,
		tbodyNode: t.querySelector("tbody")
	};
}
function tn(e, t) {
	let n = t.querySelectorAll(e);
	for (let e = 0; e < n.length; e++) n[e].style.visibility = "hidden";
}
var nn = class {
	state;
	emitUpdate;
	tableId;
	tablePos;
	tableElement;
	menuFrozen = !1;
	mouseState = "up";
	prevWasEditable = null;
	constructor(e, t, n) {
		this.editor = e, this.pmView = t, this.emitUpdate = () => {
			if (!this.state) throw Error("Attempting to update uninitialized image toolbar");
			n(this.state);
		}, t.dom.addEventListener("mousemove", this.mouseMoveHandler), t.dom.addEventListener("mousedown", this.viewMousedownHandler), window.addEventListener("mouseup", this.mouseUpHandler), t.root.addEventListener("dragover", this.dragOverHandler), t.root.addEventListener("drop", this.dropHandler);
	}
	viewMousedownHandler = () => {
		this.mouseState = "down";
	};
	mouseUpHandler = (e) => {
		this.mouseState = "up", this.mouseMoveHandler(e);
	};
	mouseMoveHandler = (e) => {
		if (this.menuFrozen || this.mouseState === "selecting" || !(e.target instanceof Element) || !this.pmView.dom.contains(e.target)) return;
		let t = en(e.target);
		if (t?.type === "cell" && this.mouseState === "down" && !this.state?.draggingState) {
			this.mouseState = "selecting", this.state?.show && (this.state.show = !1, this.state.showAddOrRemoveRowsButton = !1, this.state.showAddOrRemoveColumnsButton = !1, this.emitUpdate());
			return;
		}
		if (!t || !this.editor.isEditable) {
			this.state?.show && (this.state.show = !1, this.state.showAddOrRemoveRowsButton = !1, this.state.showAddOrRemoveColumnsButton = !1, this.emitUpdate());
			return;
		}
		if (!t.tbodyNode) return;
		let r = t.tbodyNode.getBoundingClientRect(), i = vt(t.domNode, this.pmView);
		if (!i) return;
		this.tableElement = i.node;
		let a, o = this.editor.transact((e) => n(i.id, e.doc));
		if (!o) throw Error(`Block with ID ${i.id} not found`);
		let s = p(o.node, this.editor.pmSchema, this.editor.schema.blockSchema, this.editor.schema.inlineContentSchema, this.editor.schema.styleSchema);
		if (h(this.editor, "table") && (this.tablePos = o.posBeforeNode + 1, a = s), !a) return;
		this.tableId = i.id;
		let c = t.domNode.closest(".tableWrapper")?.querySelector(".table-widgets-container");
		if (t?.type === "wrapper") {
			let t = e.clientY >= r.bottom - 1 && e.clientY < r.bottom + 20, n = e.clientX >= r.right - 1 && e.clientX < r.right + 20, i = this.state?.block.id !== a.id || e.clientX > r.right || e.clientY > r.bottom;
			this.state = {
				...this.state,
				show: !0,
				showAddOrRemoveRowsButton: t,
				showAddOrRemoveColumnsButton: n,
				referencePosTable: r,
				block: a,
				widgetContainer: c,
				colIndex: i ? void 0 : this.state?.colIndex,
				rowIndex: i ? void 0 : this.state?.rowIndex,
				referencePosCell: i ? void 0 : this.state?.referencePosCell
			};
		} else {
			let e = Z(t.domNode), n = Z(t.domNode.parentElement), o = t.domNode.getBoundingClientRect();
			if (this.state !== void 0 && this.state.show && this.tableId === i.id && this.state.rowIndex === n && this.state.colIndex === e) return;
			this.state = {
				show: !0,
				showAddOrRemoveColumnsButton: e === a.content.rows[0].cells.length - 1,
				showAddOrRemoveRowsButton: n === a.content.rows.length - 1,
				referencePosTable: r,
				block: a,
				draggingState: void 0,
				referencePosCell: o,
				colIndex: e,
				rowIndex: n,
				widgetContainer: c
			};
		}
		return this.emitUpdate(), !1;
	};
	dragOverHandler = (e) => {
		if (this.state?.draggingState === void 0) return;
		e.preventDefault(), e.dataTransfer.dropEffect = "move", tn(".prosemirror-dropcursor-block, .prosemirror-dropcursor-inline", this.pmView.root);
		let t = {
			left: Math.min(Math.max(e.clientX, this.state.referencePosTable.left + 1), this.state.referencePosTable.right - 1),
			top: Math.min(Math.max(e.clientY, this.state.referencePosTable.top + 1), this.state.referencePosTable.bottom - 1)
		}, n = this.pmView.root.elementsFromPoint(t.left, t.top).filter((e) => e.tagName === "TD" || e.tagName === "TH");
		if (n.length === 0) return;
		let r = n[0], i = !1, a = Z(r.parentElement), o = Z(r), s = this.state.draggingState.draggedCellOrientation === "row" ? this.state.rowIndex : this.state.colIndex, c = (this.state.draggingState.draggedCellOrientation === "row" ? a : o) !== s;
		(this.state.rowIndex !== a || this.state.colIndex !== o) && (this.state.rowIndex = a, this.state.colIndex = o, this.state.referencePosCell = r.getBoundingClientRect(), i = !0);
		let l = this.state.draggingState.draggedCellOrientation === "row" ? t.top : t.left;
		this.state.draggingState.mousePos !== l && (this.state.draggingState.mousePos = l, i = !0), i && this.emitUpdate(), c && this.editor.transact((e) => e.setMeta(Q, !0));
	};
	dropHandler = (e) => {
		if (this.mouseState = "up", this.state === void 0 || this.state.draggingState === void 0) return !1;
		if (this.state.rowIndex === void 0 || this.state.colIndex === void 0) throw Error("Attempted to drop table row or column, but no table block was hovered prior.");
		e.preventDefault();
		let { draggingState: n, colIndex: i, rowIndex: a } = this.state;
		this.state.draggingState = void 0;
		let o = this.state.block.content.columnWidths;
		if (n.draggedCellOrientation === "row") {
			if (!r(this.state.block, n.originalIndex, a)) return !1;
			let e = d(this.state.block, n.originalIndex, a);
			this.editor.updateBlock(this.state.block, {
				type: "table",
				content: {
					...this.state.block.content,
					rows: e
				}
			});
		} else {
			if (!l(this.state.block, n.originalIndex, i)) return !1;
			let e = t(this.state.block, n.originalIndex, i), [r] = o.splice(n.originalIndex, 1);
			o.splice(i, 0, r), this.editor.updateBlock(this.state.block, {
				type: "table",
				content: {
					...this.state.block.content,
					columnWidths: o,
					rows: e
				}
			});
		}
		return this.editor.setTextCursorPosition(this.state.block.id), !0;
	};
	update() {
		if (!this.state || !this.state.show) return;
		if (this.state.block = this.editor.getBlock(this.state.block.id), !this.state.block || this.state.block.type !== "table" || !this.tableElement?.isConnected) {
			this.state.show = !1, this.state.showAddOrRemoveRowsButton = !1, this.state.showAddOrRemoveColumnsButton = !1, this.emitUpdate();
			return;
		}
		let { height: e, width: t } = ie(this.state.block);
		this.state.rowIndex !== void 0 && this.state.colIndex !== void 0 && (this.state.rowIndex >= e && (this.state.rowIndex = e - 1), this.state.colIndex >= t && (this.state.colIndex = t - 1));
		let n = this.tableElement.querySelector("tbody");
		if (!n) throw Error("Table block does not contain a 'tbody' HTML element. This should never happen.");
		if (this.state.rowIndex !== void 0 && this.state.colIndex !== void 0) {
			let e = n.children[this.state.rowIndex].children[this.state.colIndex];
			e ? this.state.referencePosCell = e.getBoundingClientRect() : (this.state.rowIndex = void 0, this.state.colIndex = void 0);
		}
		this.state.referencePosTable = n.getBoundingClientRect(), this.emitUpdate();
	}
	destroy() {
		this.pmView.dom.removeEventListener("mousemove", this.mouseMoveHandler), window.removeEventListener("mouseup", this.mouseUpHandler), this.pmView.dom.removeEventListener("mousedown", this.viewMousedownHandler), this.pmView.root.removeEventListener("dragover", this.dragOverHandler), this.pmView.root.removeEventListener("drop", this.dropHandler);
	}
}, Q = new x("TableHandlesPlugin"), rn = v(({ editor: e }) => {
	let t, n = _(void 0);
	return {
		key: "tableHandles",
		store: n,
		prosemirrorPlugins: [new b({
			key: Q,
			view: (r) => (t = new nn(e, r, (e) => {
				n.setState(e.block ? {
					...e,
					draggingState: e.draggingState ? { ...e.draggingState } : void 0
				} : void 0);
			}), t),
			props: { decorations: (e) => {
				if (t === void 0 || t.state === void 0 || t.state.draggingState === void 0 || t.tablePos === void 0) return;
				let n = t.state.draggingState.draggedCellOrientation === "row" ? t.state.rowIndex : t.state.colIndex;
				if (n === void 0) return;
				let i = [], { block: o, draggingState: s } = t.state, { originalIndex: c, draggedCellOrientation: d } = s;
				if (n === c || !o || d === "row" && !r(o, c, n) || d === "col" && !l(o, c, n)) return T.create(e.doc, i);
				let f = e.doc.resolve(t.tablePos + 1);
				return t.state.draggingState.draggedCellOrientation === "row" ? u(t.state.block, n).forEach(({ row: t, col: r }) => {
					let a = e.doc.resolve(f.posAtIndex(t) + 1), o = e.doc.resolve(a.posAtIndex(r) + 1), s = o.node(), l = o.pos + (n > c ? s.nodeSize - 2 : 0);
					i.push(w.widget(l, () => {
						let e = document.createElement("div");
						return e.className = "bn-table-drop-cursor", e.style.left = "0", e.style.right = "0", n > c ? e.style.bottom = "-2px" : e.style.top = "-3px", e.style.height = "4px", e;
					}));
				}) : a(t.state.block, n).forEach(({ row: t, col: r }) => {
					let a = e.doc.resolve(f.posAtIndex(t) + 1), o = e.doc.resolve(a.posAtIndex(r) + 1), s = o.node(), l = o.pos + (n > c ? s.nodeSize - 2 : 0);
					i.push(w.widget(l, () => {
						let e = document.createElement("div");
						return e.className = "bn-table-drop-cursor", e.style.top = "0", e.style.bottom = "0", n > c ? e.style.right = "-2px" : e.style.left = "-3px", e.style.width = "4px", e;
					}));
				}), T.create(e.doc, i);
			} }
		})],
		colDragStart(n) {
			if (t === void 0 || t.state === void 0 || t.state.colIndex === void 0) throw Error("Attempted to drag table column, but no table block was hovered prior.");
			t.state.draggingState = {
				draggedCellOrientation: "col",
				originalIndex: t.state.colIndex,
				mousePos: n.clientX
			}, t.emitUpdate(), e.transact((e) => e.setMeta(Q, {
				draggedCellOrientation: t.state.draggingState.draggedCellOrientation,
				originalIndex: t.state.colIndex,
				newIndex: t.state.colIndex,
				tablePos: t.tablePos
			})), !e.headless && (Qt(e.prosemirrorView.root), n.dataTransfer.setDragImage(X, 0, 0), n.dataTransfer.effectAllowed = "move");
		},
		rowDragStart(n) {
			if (t.state === void 0 || t.state.rowIndex === void 0) throw Error("Attempted to drag table row, but no table block was hovered prior.");
			t.state.draggingState = {
				draggedCellOrientation: "row",
				originalIndex: t.state.rowIndex,
				mousePos: n.clientY
			}, t.emitUpdate(), e.transact((e) => e.setMeta(Q, {
				draggedCellOrientation: t.state.draggingState.draggedCellOrientation,
				originalIndex: t.state.rowIndex,
				newIndex: t.state.rowIndex,
				tablePos: t.tablePos
			})), !e.headless && (Qt(e.prosemirrorView.root), n.dataTransfer.setDragImage(X, 0, 0), n.dataTransfer.effectAllowed = "copyMove");
		},
		dragEnd() {
			if (t.state === void 0) throw Error("Attempted to drag table row, but no table block was hovered prior.");
			t.state.draggingState = void 0, t.emitUpdate(), e.transact((e) => e.setMeta(Q, null)), !e.headless && $t(e.prosemirrorView.root);
		},
		freezeHandles() {
			t.menuFrozen = !0;
		},
		unfreezeHandles() {
			t.menuFrozen = !1;
		},
		hideHandlesIfNotFrozen() {
			!t.menuFrozen && t.state?.show && (t.state.show = !1, t.state.showAddOrRemoveRowsButton = !1, t.state.showAddOrRemoveColumnsButton = !1, t.emitUpdate());
		},
		getCellsAtRowHandle(e, t) {
			return u(e, t);
		},
		getCellsAtColumnHandle(e, t) {
			return a(e, t);
		},
		setCellSelection(e, n, r = n) {
			if (!t) throw Error("Table handles view not initialized");
			let i = e.doc.resolve(t.tablePos + 1), a = e.doc.resolve(i.posAtIndex(n.row) + 1), o = e.doc.resolve(a.posAtIndex(n.col)), s = e.doc.resolve(i.posAtIndex(r.row) + 1), c = e.doc.resolve(s.posAtIndex(r.col)), l = e.tr;
			return l.setSelection(new ge(o, c)), e.apply(l);
		},
		addRowOrColumn(t, n) {
			e.exec((e, r) => {
				let i = this.setCellSelection(e, n.orientation === "row" ? {
					row: t,
					col: 0
				} : {
					row: 0,
					col: t
				});
				return n.orientation === "row" ? n.side === "above" ? be(i, r) : ye(i, r) : n.side === "left" ? ve(i, r) : _e(i, r);
			});
		},
		removeRowOrColumn(t, n) {
			return n === "row" ? e.exec((e, n) => Se(this.setCellSelection(e, {
				row: t,
				col: 0
			}), n)) : e.exec((e, n) => xe(this.setCellSelection(e, {
				row: 0,
				col: t
			}), n));
		},
		mergeCells(t) {
			return e.exec((e, n) => Ce(t ? this.setCellSelection(e, t.relativeStartCell, t.relativeEndCell) : e, n));
		},
		splitCell(t) {
			return e.exec((e, n) => we(t ? this.setCellSelection(e, t) : e, n));
		},
		getCellSelection() {
			return e.transact((e) => {
				let t = e.selection, n = t.$from, r = t.$to;
				if (f(t)) {
					let { ranges: e } = t;
					e.forEach((e) => {
						n = e.$from.min(n ?? e.$from), r = e.$to.max(r ?? e.$to);
					});
				} else if (n = e.doc.resolve(t.$from.pos - t.$from.parentOffset - 1), r = e.doc.resolve(t.$to.pos - t.$to.parentOffset - 1), n.pos === 0 || r.pos === 0) return;
				let i = e.doc.resolve(n.pos - n.parentOffset - 1), a = e.doc.resolve(r.pos - r.parentOffset - 1), o = e.doc.resolve(i.pos - i.parentOffset - 1), s = n.index(i.depth), c = i.index(o.depth), l = r.index(a.depth), u = a.index(o.depth), d = [];
				for (let e = c; e <= u; e++) for (let t = s; t <= l; t++) d.push({
					row: e,
					col: t
				});
				return {
					from: {
						row: c,
						col: s
					},
					to: {
						row: u,
						col: l
					},
					cells: d
				};
			});
		},
		getMergeDirection(t) {
			return e.transact((e) => {
				let n = f(e.selection) ? e.selection : void 0;
				if (!n || !t || n.ranges.length <= 1) return;
				let r = this.getCellSelection();
				if (r) return s(r.from, r.to, t) ? "vertical" : "horizontal";
			});
		},
		cropEmptyRowsOrColumns(e, t) {
			return i(e, t);
		},
		addRowsOrColumns(e, t, n) {
			return o(e, t, n);
		}
	};
}), $ = new x("trailingNode");
function an(e, t) {
	if (!t) return !1;
	let n = e.lastChild?.lastChild, r = n?.firstChild;
	return !(n?.type.name === "blockContainer" && r?.type.name === "paragraph" && r.content.size === 0);
}
var on = v(({ editor: e }) => {
	function t(t) {
		return w.widget(t, () => {
			let t = document.createElement("div");
			return t.className = "bn-trailing-block", t.contentEditable = "false", t.addEventListener("mousedown", (t) => {
				t.preventDefault(), e.transact((t) => {
					let [n] = e.insertBlocks([{ type: "paragraph" }], e.document[e.document.length - 1], "after");
					e.setTextCursorPosition(n, "start"), t.scrollIntoView();
				}), e.prosemirrorView?.focus();
			}), t;
		}, { side: 1 });
	}
	function n(e, n, r) {
		let i = n.map(e.mapping, e.doc), a = i.find(), o = a.length > 0;
		return o === an(e.doc, r) ? i : o ? i.remove(a) : i.add(e.doc, [t(e.doc.content.size - 1)]);
	}
	return {
		key: "trailingNode",
		prosemirrorPlugins: [new b({
			key: $,
			state: {
				init: (t, r) => n(r.tr, T.empty, e.isEditable),
				apply: (t, r) => !t.docChanged && !t.getMeta($) ? r : n(t, r, e.isEditable)
			},
			view(e) {
				let t = e.editable;
				return { update(e) {
					e.editable !== t && (t = e.editable, e.dispatch(e.state.tr.setMeta($, !0)));
				} };
			},
			props: { decorations: (e) => $.getState(e) }
		})]
	};
});
//#endregion
export { j as C, Ke as D, qe as E, O, Ze as S, k as T, ct as _, Zt as a, ot as b, Jt as c, W as d, _t as f, lt as g, ut as h, Q as i, Vt as l, ft as m, rn as n, Yt as o, mt as p, nn as r, J as s, on as t, Bt as u, st as v, A as w, $e as x, at as y };

//# sourceMappingURL=extensions-D2mx2C9y.js.map